import { Logger as clientLogger } from 'beaver-logger'
import serverData from '../utils/server-data'

const { isProd } = serverData

export default clientLogger({
  url: '/altpayfields/log',
  // Log level to display in the browser console
  logLevel: isProd ? 'error' : 'debug',
})
